import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'transition-opacity'
  },
  variants: {
    fixed: {
      true: {
        base: 'shadow-header'
      }
    },
    positioning: {
      sticky: {
        base: 'sticky top-0 z-30'
      },
      fixed: {
        base: 'fixed right-0 left-0'
      }
    }
  },
  defaultVariants: {
    fixed: false
  }
});
